export default "__VITE_ASSET__BxRALvBw__"